(function () {
  const sliders = [];

  const initSlider = (section) => {
    const sliderEl = section.querySelector(".js-popular-products-slider");
    if (!sliderEl) return;

    const swiperWrapper = sliderEl.querySelector(
      ".popular-products__list--slider"
    );
    const slides = sliderEl.querySelectorAll(".popular-products__item");

    if (!swiperWrapper || !slides || !slides.length) return;

    if (sliderEl.swiper && !sliderEl.swiper.destroyed) {
      sliderEl.swiper.update();
      return;
    }

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 4);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    const prevBtn = section.querySelector(
      ".heading-group-secondary__navigation-button-prev"
    );
    const nextBtn = section.querySelector(
      ".heading-group-secondary__navigation-button-next"
    );
    const paginationElem = section.querySelector(
      ".heading-group-secondary__navigation .swiper-pagination"
    );
    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1360 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1600 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 2,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      autoplay: false,
      mousewheel: false,
      pagination: {
        el: paginationElem,
        type: "progressbar",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
        },
        1360: {
          slidesPerView: slidesPerView1360,
        },
        1600: {
          slidesPerView: slidesPerView1600,
        },
      },
    };

    const slider = new Swiper(sliderEl, sliderSettings);
    sliders.push(slider);
  };

  const destroySliders = () => {
    sliders.forEach((slider) => {
      if (typeof slider.destroy === "function") {
        slider.destroy();
      }
    });
  };

  const syncAnimationIndexes = (items) => {
    items.forEach((el) => {
      if (el.dataset.iGlobal != null) {
        el.style.setProperty("--i-global", el.dataset.iGlobal);
      }

      if (el.dataset.iLocal != null) {
        el.style.setProperty("--i-local", el.dataset.iLocal);
      }
    });
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("popular-products-section")) {
      return;
    }

    const box = section.querySelector(".popular-products");

    if (!box) return;

    const productsItems = box.querySelectorAll(".popular-products__item");
    let animationFrame;

    syncAnimationIndexes(productsItems);

    box.addEventListener("filter:change", (event) => {

      // Update the section CTA link to match the active tab
      const tabLinksRaw = box.dataset.tabLinks;
      const activeFilterBtn = box.querySelector("[data-filter-target].active");
      const ctaBtn = box.querySelector(".popular-products__btn");

      if (tabLinksRaw && ctaBtn && activeFilterBtn) {
        try {
          const tabLinks = JSON.parse(tabLinksRaw);
          const target = activeFilterBtn.dataset.filterTarget;
          const nextHref = tabLinks[target] || tabLinks._all;

          if (nextHref) {
            ctaBtn.setAttribute("href", nextHref);
            ctaBtn.removeAttribute("aria-disabled");
          }
        } catch (err) {
          /* ignore malformed tab link map */
        }
      }
      const visibleItems = event.detail?.visibleItems || [];

      if (!visibleItems.length) return;

      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }

      visibleItems.forEach((item, index) => {
        item.classList.remove("in-view");
        item.style.setProperty("--i-local", index);
      });

      // Commit the reset before starting the same keyframes again.
      void box.offsetWidth;

      animationFrame = requestAnimationFrame(() => {
        visibleItems.forEach((item) => {
          item.classList.add("in-view");
        });
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    productsItems.forEach((item) => {
      observer.observe(item);
    });

    const isSlider = box.dataset.layout;

    function mobileSlider() {
      if (isSlider) {
        initSlider(box);
      } else {
        destroySliders();
      }
    }

    mobileSlider();
    window.addEventListener("resize", mobileSlider);
  };

  const popularProducts = document.querySelectorAll(
    ".popular-products-section"
  );

  popularProducts.forEach((popularProduct) => {
    initProductsTabs(popularProduct);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
  });
})();
